import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const holidays = [
    {
        key: "administration-holiday",
        path: `${APP_PREFIX_PATH}/holiday`,
        component: React.lazy(() => import("views/app-views/holiday")),
        meta: {
            permission: "LIST_HOLIDAY"
        }
    },

    {
        key: "administration-holiday-add",
        path: `${APP_PREFIX_PATH}/holiday/add/`,
        component: React.lazy(() => import("views/app-views/holiday/add")),
        meta: {
            permission: "ADD_HOLIDAY"
        }
    },

    {
        key: "administration-holiday-edit",
        path: `${APP_PREFIX_PATH}/holiday/add/:id`,
        component: React.lazy(() => import("views/app-views/holiday/add")),
        meta: {
            permission: "EDIT_HOLIDAY"
        }
    },
]



